import { getType, ActionType } from "typesafe-actions";
import { PopupOrderState, PopupOrderStatus } from "../../types/state/ui/PopupOrderState";
import { popupOrderActions } from "../../actions/ui/popup-order.actions";

export const popupOrderInitialState: PopupOrderState = {
    order: []
}

export const popupOrderReducer = (
    state = popupOrderInitialState,
    action: ActionType<typeof popupOrderActions[keyof typeof popupOrderActions]>): PopupOrderState => {
    switch (action.type) {
        case getType(popupOrderActions.init):
            return {
                ...state,
                order: action.payload.order
            }
        case getType(popupOrderActions.markAsShown):
            const current = state.order.find(x => x.status === PopupOrderStatus.Wait);
            return {
                ...state,
                order: state.order.map(x => x === current
                    ? {
                        ...x,
                        status: PopupOrderStatus.Shown
                    } : x)
            };
        case getType(popupOrderActions.markAsWait):
            return {
                ...state,
                order: state.order.map(o => o.popup === action.payload.popupType
                    ? {
                        ...o,
                        status: PopupOrderStatus.Wait
                    } : o)
            };
        default: return state;
    }
}
